import { render } from "./DeviceDeleteForm.vue?vue&type=template&id=32e24a86"
import script from "./DeviceDeleteForm.vue?vue&type=script&lang=js"
export * from "./DeviceDeleteForm.vue?vue&type=script&lang=js"
script.render = render

export default script